import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    <img className="region-title-map" src={`../images/map-hill-country.png`} />
    Hill Country
  </span>;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AdGroup = makeShortcode("AdGroup");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const StatePark = makeShortcode("StatePark");
const RegionListing = makeShortcode("RegionListing");
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`A bucolic landscape rich with cultural and natural attractions reflects Texas’ rural heritage`}</p>
    </PageDescription>
    <AdGroup id={['ad08', 'ad17']} mdxType="AdGroup" />
    <Row mdxType="Row">
      <Column colSm={12} colMd={6} colLg={10} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEEAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB25OxInB//8QAHRAAAgIBBQAAAAAAAAAAAAAAAAIBAxMEERIUIf/aAAgBAQABBQKdSuTsyZaxKdjh41Cn/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BiP/EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAECAQE/Aaf/xAAbEAABBAMAAAAAAAAAAAAAAAAAAQIRMRASIf/aAAgBAQAGPwJdZKU64sicf//EABkQAAMBAQEAAAAAAAAAAAAAAAABETEhQf/aAAgBAQABPyGyspqOA0zorPiDpGwVa8P/2gAMAwEAAgADAAAAEOcP/8QAFhEAAwAAAAAAAAAAAAAAAAAAEBFB/9oACAEDAQE/EEof/8QAFxEBAAMAAAAAAAAAAAAAAAAAACFRYf/aAAgBAgEBPxDCLf/EABwQAAIDAQADAAAAAAAAAAAAAAERACExQWGhwf/aAAgBAQABPxA0mQHQUGVeQiak+IoKbL4b+xkDtmIehGDJiZkU/cTrB2f/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "The exterior of a meager log cabin with a tin roof and a small sign reading 'Waco Cabin'",
            "title": "The exterior of a meager log cabin with a tin roof and a small sign reading 'Waco Cabin'",
            "src": "/static/255a3e87035034fb12a70eb783fab4f1/2e753/hill-country-the-kendall.jpg",
            "srcSet": ["/static/255a3e87035034fb12a70eb783fab4f1/69549/hill-country-the-kendall.jpg 288w", "/static/255a3e87035034fb12a70eb783fab4f1/473e3/hill-country-the-kendall.jpg 576w", "/static/255a3e87035034fb12a70eb783fab4f1/2e753/hill-country-the-kendall.jpg 1152w", "/static/255a3e87035034fb12a70eb783fab4f1/74f4b/hill-country-the-kendall.jpg 1728w", "/static/255a3e87035034fb12a70eb783fab4f1/12e8d/hill-country-the-kendall.jpg 1800w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">The Waco Cabin at The Kendall in Boerne. Photo by Tiffany Hofeldt</Caption>
        <h2><strong parentName="h2">{`A Creek Runs Through It`}</strong></h2>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={12} colMd={6} colLg={8} mdxType="Column">
        <h3>{`Hill Country charm and Texas-German heritage fuel a fulfilling getaway`}</h3>
        <p><strong parentName="p">{`By Jacqueline Knox`}</strong></p>
        <p>{`The German immigrants who settled in the Boerne area in 1850 knew a pristine townsite when they saw one. The colonists built farms near the bank of Cibolo Creek, the spring-fed stream that anchors the town of Boerne to this day. Named for German political writer Karl Ludwig Börne, the town evolved into a health resort in the late 19th century after multiple sanitariums opened. The town’s relatively high and dry Hill Country environs were thought to be beneficial to people with chronic illnesses. The railroad and agriculture also bolstered Boerne’s economy, and the town’s proximity to San Antonio has contributed to both a growing population and a steady stream of tourists. Boerne’s German heritage is alive and well in the town’s annual festivals, restaurants, and restored historic buildings lining Main Street.`}</p>
      </Column>
      <Column colSm={3} colMd={2} colLg={3} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "528px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "186.80555555555557%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "A map showing distances from Boerne",
            "title": "A map showing distances from Boerne",
            "src": "/static/6f0c103ef49153c078f7808a6987b38d/3d774/hill-country-map-boerne.png",
            "srcSet": ["/static/6f0c103ef49153c078f7808a6987b38d/7fc1e/hill-country-map-boerne.png 288w", "/static/6f0c103ef49153c078f7808a6987b38d/3d774/hill-country-map-boerne.png 528w"],
            "sizes": "(max-width: 528px) 100vw, 528px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={12} colMd={5} colLg={8} mdxType="Column">
        <h3>{`Stay`}</h3>
        <h4>{`The Kendall`}</h4>
        <p>{`Built as a home in 1859, The Kendall’s lodging tradition began in the late 1800s when the Reed family boarded travelers. Now, The Kendall features 34 rooms, cottages, and suites—starting at $150/night—including a restored chapel. Hotel restaurant Peggy’s on the Green is a
destination for refined comfort food.`}</p>
        <h3>{`Shop`}</h3>
        <h4>{`Flashback Funtiques`}</h4>
        <p>{`Located on Main Street, this store specializes in nostalgia, such as Big Boy statues, pinball machines, and jukeboxes. Owner Billy Howard hunts for vintage items at flea markets, car shows, and even attics, meaning you never know what treasures you’ll find. With its neon lights and roadside relics, the store is hard to miss.`}</p>
        <h3>{`See`}</h3>
        <h4>{`Cibolo Center for Conservation`}</h4>
        <p>{`Previously named the Cibolo Nature Center, this peaceful reserve has more than 6 miles of trails along the cypress-lined banks of Cibolo Creek. Make sure to visit the nearby Herff Farm, which has community gardens, yoga classes, and a Saturday farmers market.`}</p>
        <h4>{`Cascade Caverns`}</h4>
        <p>{`Venture below ground at Boerne’s oldest attraction to see the beauty of this living limestone cave where formations are still growing. Guided tours explore the high ceilings of the Cathedral Room and the bones of a prehistoric saber-toothed tiger and an American bison.`}</p>
        <h3>{`Eat`}</h3>
        <h4>{`Mary’s Tacos`}</h4>
        <p>{`There’s always a line at this family-owned haven for breakfast tacos. Try the “Sean”—eggs, bacon, potatoes, beans, and cheese—or the “Poncho”—brisket sauteed with jalapeños, tomatoes, and onions. Both come wrapped in homemade flour tortillas. Mary’s also serves lunch until 1:30 p.m., including barbacoa by the pound.`}</p>
        <h4>{`Cibolo Creek Brewing Company`}</h4>
        <p>{`This local brewery creates both classic and adventurous beers, including the Boerne Blonde and Creekside IPA. Owned by two local families, Cibolo Creek is a popular place to grab a pint, order a burger, and kick it outside. During the spring and summer, catch live music on the patio.`}</p>
        <h4>{`The Dienger Trading Co.`}</h4>
        <p>{`The Dienger Trading Co.’s 1884 building has housed a grocery store, restaurant, public library, and offices over the decades. Now back to its roots in food, the bistro and bakery right off Boerne’s Main Plaza offers breakfast and lunch on weekdays, and brunch on weekends. There’s also a shop carrying clothing, décor, and gifts.`}</p>
        <h4>{`The Dodging Duck Brewhaus`}</h4>
        <p>{`Named for the ubiquitous ducks on Cibolo Creek, this craft brewery serves sausages, giant pretzels, and beers that pay homage to the town’s German heritage. Sit on the patio and enjoy a laugh while cars stop in the street to let the “dodging ducks” pass by.`}</p>
        <h3>{`Old World Melodies`}</h3>
        <p>{`The Boerne Village Band bills itself as the oldest continuously running German band in the world outside of Germany itself. Organized in 1860, the band persevered through the Civil War and World Wars I and II, and sometimes featured multiple generations of musicians from the same families. More recently, the German government has donated sheet music and instruments to the band in appreciation of its commitment to German music, while the Texas House of Representatives recognized the band in 1991 with a resolution honoring it for “keeping alive German music as part of our heritage.” Now in its 163rd year, the Boerne Village Band performs a summer concert series on the town plaza and also plays events, including the Kendall County Fair. `}<a parentName="p" {...{
            "href": "http://boernevillageband.com"
          }}>{`boernevillageband.com`}</a></p>
        <h3>{`RV Info`}</h3>
        <p>{`Top of the Hill RV Resort & Cabins, roughly 7 miles north of downtown Boerne, offers cabins and RV camping, showers, kitchens, a swimming pool, a fitness room, laundry facilities, and a general store. 12 Green Cedar Road. 830-537-3666; `}<a parentName="p" {...{
            "href": "http://topofthehillrvresort.com"
          }}>{`topofthehillrvresort.com`}</a></p>
      </Column>
      <Column colSm={12} colMd={3} colLg={3} mdxType="Column">
        <StatePark mdxType="StatePark">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "150.34722222222223%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAIEAQMF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAECA//aAAwDAQACEAMQAAABaOpcl553LKX3JqQYZ//EAB0QAAICAQUAAAAAAAAAAAAAAAECABEDEhMiMkH/2gAIAQEAAQUCVQV9dOSE04jA3jvSQxV921Wx1BYz/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQMBAT8BKf/EABURAQEAAAAAAAAAAAAAAAAAABEg/9oACAECAQE/ASP/xAAbEAACAgMBAAAAAAAAAAAAAAAAMQEQAhEhUf/aAAgBAQAGPwKPbg2ITOnMZHf/xAAeEAACAwABBQAAAAAAAAAAAAAAEQEhMRBBUWGBof/aAAgBAQABPyGxkjFrqeMd4wieJSN4ZiolSWA/WkpZ6RJTUloY1fw//9oADAMBAAIAAwAAABDrw/L/xAAWEQEBAQAAAAAAAAAAAAAAAAARABD/2gAIAQMBAT8QMIX/xAAYEQEBAAMAAAAAAAAAAAAAAAABABARIf/aAAgBAgEBPxAQxuXuP//EAB4QAQADAAICAwAAAAAAAAAAAAEAESExQVFhkaHx/9oACAEBAAE/EL6oDBzkL7VTPya0AO1d1NhdEuu5uP2ez3HWpoe7lKbHkqeePmIbEWKWY1WICPNEpyDws02FRbbni4ccWu2fZP/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "A group of people walk down a trail in a wooded area",
              "title": "A group of people walk down a trail in a wooded area",
              "src": "/static/0d06da449e172204c564e45050be40a3/2e753/hill-country-south-llano.jpg",
              "srcSet": ["/static/0d06da449e172204c564e45050be40a3/69549/hill-country-south-llano.jpg 288w", "/static/0d06da449e172204c564e45050be40a3/473e3/hill-country-south-llano.jpg 576w", "/static/0d06da449e172204c564e45050be40a3/2e753/hill-country-south-llano.jpg 1152w", "/static/0d06da449e172204c564e45050be40a3/040c5/hill-country-south-llano.jpg 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <Caption mdxType="Caption">South Llano River State Park in Junction. Photo by Chase Fountain, TPWD</Caption>
          <h5>{`Hill Country`}</h5>
          <h3>{`Celebrate 100 Years of Texas State Parks`}</h3>
          <p>{`Join in the celebration! The Texas State Parks system is turning 100 years old in 2023. Learn more and discover all the ways you can help celebrate at `}<a parentName="p" {...{
              "href": "https://texasstateparks.org/100years"
            }}>{`texasstateparks.org/100years`}</a>{`.`}</p>
          <h4>{`South Llano River State Park`}</h4>
          <p>{`Bring your hiking boots, water toys, camping gear, and a sense of adventure. This scenic park provides a refuge for wildlife and people on the southwestern edge of the Hill Country. Tubers float 2 miles of river frontage (with multiple put-in and take-out points). Keep your eyes peeled for any of the 250 recorded bird species by day; at night, you’ll savor spectacular star-filled skies—it’s a certified International Dark Sky Park.`}</p>
          <h4>{`More Hill Country State Parks`}</h4>
          <p><strong parentName="p">{`Blanco State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Colorado Bend State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Devil’s Sinkhole State Natural Area`}</strong></p>
          <br />
          <p><strong parentName="p">{`Enchanted Rock State Natural Area`}</strong></p>
          <br />
          <p><strong parentName="p">{`Garner State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Government Canyon State Natural Area`}</strong></p>
          <br />
          <p><strong parentName="p">{`Guadalupe River State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Hill Country State Natural Area`}</strong></p>
          <br />
          <p><strong parentName="p">{`Kickapoo Cavern State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Inks Lake State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lake Brownwood State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Longhorn Cavern State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lost Maples State Natural Area`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lyndon B. Johnson State Park & Historic Site`}</strong></p>
          <br />
          <p><strong parentName="p">{`McKinney Falls State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Old Tunnel State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Pedernales Falls State Park`}</strong></p>
          <br />
        </StatePark>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={6} colMd={4} colLg={8} mdxType="Column">
        <RegionListing title="Hill Country" color="blue" region="HILL COUNTRY" ads={['ad44', 'ad77', 'ad94', 'ad50']} mdxType="RegionListing" />
      </Column>
      <Column colSm={6} colMd={4} colLg={4} mdxType="Column">
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      